module.exports = __webpack_public_path__ + "static/media/portfolio5.46711d90.jpg";